var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.svg)?_c('inline-svg',{staticClass:"xentral-icon",class:['xentral-icon--' + _vm.size, 'xentral-icon--' + _vm.color],attrs:{"src":_setup.svg}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }